import { Routes } from '@angular/router';
import { AuthGuardService } from './authentication/auth-guard.service';
import { AcceptOfferComponent } from './pages/accept-offer/accept-offer.component';
import { DeclineOfferComponent } from './pages/decline-offer/decline-offer.component';
import { EditInformationComponent } from './pages/edit-information/edit-information.component';
import { ErrorComponent } from './pages/error/error.component';
import { OfferStatusComponent } from './pages/offer-status/offer-status.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { RequestInformationComponent } from './pages/request-information/request-information.component';
import { ThankYouAcceptComponent } from './pages/thank-you-accept/thank-you-accept.component';
import { ThankYouComponent } from './pages/thank-you/thank-you.component';
import { VerificationCodeComponent } from './pages/verification-code/verification-code.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';

export const routes: Routes = [
  { path: '', component: RedirectComponent, pathMatch: 'full' },
  { path: 'accepteren/:customerId/:customerHash/:valuationId/:valuationHash', component: AcceptOfferComponent, canActivate: [AuthGuardService] },
  { path: 'accepteren', component: AcceptOfferComponent, canActivate: [AuthGuardService] },
  { path: 'afwijzen', component: DeclineOfferComponent },
  { path: 'afwijzen/:customerId/:customerHash/:valuationId/:valuationHash', component: DeclineOfferComponent },
  { path: 'verificatie', component: VerificationCodeComponent },
  { path: 'informatie-aanleveren', component: RequestInformationComponent, canActivate: [AuthGuardService] },
  { path: 'informatie-aanleveren/:customerId/:customerHash/:valuationId/:valuationHash', component: RequestInformationComponent, canActivate: [AuthGuardService] },
  { path: 'informatie-bewerken', component: EditInformationComponent, canActivate: [AuthGuardService] },
  { path: 'informatie-bewerken/:customerId/:customerHash/:valuationId/:valuationHash', component: EditInformationComponent, canActivate: [AuthGuardService] },
  { path: 'status', component: OfferStatusComponent, canActivate: [AuthGuardService] },
  { path: 'status/:customerId/:customerHash/:valuationId/:valuationHash', component: OfferStatusComponent, canActivate: [AuthGuardService] },
  { path: 'bedankt-accepteren', component: ThankYouAcceptComponent },
  { path: 'bedankt', component: ThankYouComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'maintenance', component: MaintenanceComponent },
];
